import { subscriptionStore } from '../store/subscriptionStore' 

export class ShipmentZones {
	constructor (vars) {
		var shipmentZones = []
		vars.src.forEach(r => {
			if (r.delivery_date_estimated === '2019-11-01 00:00:00') return
				
			shipmentZones.push(r)
		})

		return shipmentZones
	}
}
